
/**
 * 合格ダイアリー - 実績レポート画面 - 週間グラフ
 */
import { computed, defineComponent, PropType, ref, watch, onMounted } from 'vue'
import {
  SelectedLabelItem,
  isLabelChecked,
  getColor,
} from '@/components/views/PassDiary/Common'
import { UserScheduleSummary } from '@/typings/PassDiary'

type CanvasContextType = CanvasRenderingContext2D | null | undefined

const CANVAS_HEIGHT: number = 410
const CANVAS_WIDTH: number = 375
const CANVAS_CONTEXT_ID = '2d'

export default defineComponent({
  name: 'WeekReportGraph',

  props: {
    selectedItemArray: {
      type: Array as PropType<SelectedLabelItem[]>,
      required: true,
    },

    userScheduleSummary: {
      type: Array as PropType<UserScheduleSummary[]>,
      required: true,
    },
    targetDate: {
      type: Date,
      required: true,
    },
  },

  setup(props) {
    onMounted(() => {
      paintReportGraph()
    })
    const dateArray = computed(() => {
      let arr = [] as Date[]
      for (var i = 7; i > 0; i--) {
        arr = [
          ...arr,
          new Date(props.targetDate.getTime() - i * 24 * 60 * 60 * 1000),
        ]
      }
      return arr
    })
    watch<SelectedLabelItem[]>(
      () => props.selectedItemArray,

      () => paintReportGraph()
    )
    watch<UserScheduleSummary[]>(
      () => props.userScheduleSummary,

      () => paintReportGraph()
    )
    watch<Date>(
      () => props.targetDate,

      () => paintReportGraph()
    )
    const paintReportGraph = (): void => {
      resetCanvas()
      const context = barGraphContext.value

      if (!context) {
        return
      }
      //canvas background
      context.fillStyle = '#ececec'
      context.fillRect(0, 0, 375, 410)
      //graph background
      context.fillStyle = '#ffffff'
      context.fillRect(60, 0, 315, 360)
      //縦目盛
      context.fillStyle = 'rgba(0,0,0,0.5)'
      context.font = '400 16px Noto Sans JP'
      context.textAlign = 'center'
      context.textBaseline = 'middle'
      context.strokeStyle = 'rgba(0,0,0,0.5)'
      context.lineWidth = 1

      context.beginPath()
      context.fillText('24h', 36, 24)
      context.moveTo(60, 24)
      context.lineTo(65, 24)
      context.stroke()

      context.beginPath()
      context.fillText('20h', 36, 80)
      context.moveTo(60, 80)
      context.lineTo(65, 80)
      context.stroke()
      context.beginPath()
      context.fillText('15h', 36, 150)
      context.moveTo(60, 150)
      context.lineTo(65, 150)
      context.stroke()

      context.beginPath()
      context.fillText('10h', 36, 220)
      context.moveTo(60, 220)
      context.lineTo(65, 220)
      context.stroke()
      context.beginPath()
      context.fillText('5h', 36, 290)
      context.moveTo(60, 290)
      context.lineTo(65, 290)
      context.stroke()
      //横目盛
      let d = ''
      let w = ''
      context.font = '400 12px Noto Sans JP'
      for (var i = 0; i < 7; i++) {
        d = dateArray.value[i].getDate() + ''
        w = ['日', '月', '火', '水', '木', '金', '土'][
          dateArray.value[i].getDay()
        ]

        context.beginPath()
        context.fillText(d, 100 + i * 40, 375)
        context.fillText(w, 100 + i * 40, 395)
      }
      //週間サマリー

      for (var h = 0; h < 7; h++) {
        if (!props.userScheduleSummary[h]) {
          break
        }

        var dataArr = props.userScheduleSummary[h].actual
        const dailyGraphWidth = 20
        let dailyGraphHeight = 0
        let dailyGraphEnd = 360
        let idx = 0
        for (var j = 0; j < dataArr.length; j++) {
          idx = dataArr.length - j - 1
          if (isLabelChecked(dataArr[idx].label, props.selectedItemArray)) {
            context.fillStyle = `${
              getColor(dataArr[idx].label, props.selectedItemArray).achieveColor
            }`
            dailyGraphHeight = dataArr[idx].value * 0.25
            context.fillRect(
              90 + h * 40,
              dailyGraphEnd - dailyGraphHeight,
              dailyGraphWidth,
              dailyGraphHeight
            )
            dailyGraphEnd = dailyGraphEnd - dailyGraphHeight
          }
        }
      }
    }

    const barGraphCanvas = ref<HTMLCanvasElement>()

    const barGraphContext = computed<CanvasContextType>(() =>
      barGraphCanvas.value?.getContext(CANVAS_CONTEXT_ID)
    )

    const resetCanvas = (): void => {
      if (!barGraphContext.value) {
        return
      }
      barGraphContext.value.clearRect(0, 0, CANVAS_WIDTH, CANVAS_HEIGHT)
    }

    return {
      CANVAS_HEIGHT,
      CANVAS_WIDTH,
      barGraphCanvas,
    }
  },
})
